
export enum RequisitionStatus {
    Draft = 0, 
    Submitted = 1,
    Processing = 2,
    Completed = 3,
    Incompleted = 4,
    SignaturePending = 5
}